const sessionStates = {
  DONE: 'DONE',
  HALFDONE: 'HALFDONE',
  NOTDONE: 'NOTDONE',
  INITIAL: 'INITIAL',
};

module.exports = sessionStates;
